// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"b980f4b6","456":"529b85a8","522":"085032b5","584":"c690fb6f","716":"f6afe996"}[chunkId] + ".chunk.css";
};